import { ApplicationConfig, importProvidersFrom, inject } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';

import { DialogService } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { CustomInterceptor } from './core/interceptors/custom-interceptor';
import { NavigationSpinnerService } from './core/services/navigation-spinner.service';

export const provideTranslation = () => ({
  defaultLanguage: 'es',
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient],
  },
});

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withHashLocation()),
    DialogService,
    MessageService,
    provideHttpClient(withInterceptors([CustomInterceptor])),
    provideAnimations(),
    importProvidersFrom([TranslateModule.forRoot(provideTranslation())]),
    {
      provide: NavigationSpinnerService,
      useFactory: () => inject(NavigationSpinnerService)
    }
  ]
};
